import { StyleSheet, Platform, Dimensions } from 'react-native';

import { Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes'

export default StyleSheet.create({
  container: theme => ({
    backgroundColor: theme.colors.backgroundColorSeven,
    flex: 1,
    flexDirection: 'row',
    // overflow: Platform.OS === 'web' && Dimensions.get('window').width > 700 ? null : 'scroll',
  }),
  sidebar: (isFullHeight, theme) => ({
    width: 300,
    paddingTop: 70,
    paddingBottom: 70,
    backgroundColor: theme.colors.background,
    boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.16)",
    zIndex: 100,
    height: isFullHeight ? Dimensions.get('window').height > 751 ? '100vw' : 'auto' : "fit-content",
    overflow: 'scroll'
  }),
  sidebarItem: {
    marginBottom: 20,
    marginLeft: 30,
    paddingLeft: 16
  },
  sidebarSubItem: {
    marginBottom: 10,
    marginLeft: 40,
    paddingLeft: 16
  },
  activeSidebarItem: {
    borderLeftWidth: 3,
    borderLeftColor: "#E60000",
    paddingLeft: 13,
  },
  children: {
    flex: 1,
  },
  headerNonScrollWithSpace: headerHeight => ({
    marginTop: headerHeight,
  }),
  minHeight: {
    ...Platform.select({
      web: {
        overflow: 'auto'
      },
      default: {
      }
    }),
    minHeight: Dimensions.get('window').height - 100,
    height: '100%',
  },
  logoutModalContainer: {
    flex: 1,
  },
  logoutConfirmTitle: {
    marginVertical: 25,
    fontFamily: Fonts.type.VodafoneLt,
    fontSize: Fonts.size.h4,
  },
  logoutConfirmButton: {
    marginTop: 15,
  },
});

export const headerNonScrollMargin = Platform.select({
  ios: {
    marginTop: 66,
    flex: 1,
  },
  android: {
    marginTop: 40,
    flex: 1,
  },
});
